// Librerias
import React from 'react'
let PropTypes = React.PropTypes
// CSS
import * as css from './TablaInventarios.css'
// Componentes
import HeaderConFiltro from '../../components/shared/HeaderConFiltro.jsx'
import { RowInventario} from './RowInventario.jsx'

export class TablaInventarios extends React.Component{
    render(){
        let totalInventarios = this.props.inventarios.length
        return <div className="row">
            <TablaInv filtro={this.props.filtros.filtroAprobacionSei} actualizarFiltros={this.context.actualizarFiltro}>
                {_.range(0, totalInventarios).map(index=>{
                    let inventario = this.props.inventarios[index]
                    return <RowInventario
                        permisos={this.props.permisos}
                        ref={index}
                        key={inventario? inventario.inv_idInventario : index}
                        inventario={inventario}
                        correlativo={index+1}
                        stockCliente={this.context.stockCliente.bind(this)}
                        aprobacionCliente={this.context.aprobacionCliente.bind(this)}
                        aprobacionSei={this.context.aprobacionSei.bind(this)}
                        observacionCliente={this.context.observacionCliente.bind(this)}
                    />
                })}
            </TablaInv>
        </div>
    }
}
TablaInventarios.propTypes = {
    filtros: PropTypes.objectOf(PropTypes.array).isRequired
}
TablaInventarios.contextTypes = {
    aprobacionCliente: PropTypes.func,
    aprobacionSei: PropTypes.func,
    stockCliente: PropTypes.func,
    observacionCliente: PropTypes.func,
    actualizarFiltro: PropTypes.func
}
let TablaInv = ({filtro, actualizarFiltros, children})=>
    <div className={'panel panel-primary'}>
        <div className={'panel-heading'}>Aprobación unidades inventarios</div>
        <table className={'table table-striped table-hover no-margin table-condensed '+css.tablaInventariosFCV}>
            <thead>
            <tr>
                <th className={css.thCorrelativo}>#</th>
                <th className={css.thFecha}>Fecha</th>
                <th className={css.thNumeroLocal}>Ceco</th>
                <th className={css.thNombreLocal}>Local</th>
                <th className={css.thUndInf}>Und. Inf. FCV</th>
                <th className={css.thUndSEI}>Discrepancia</th>
                <th className={css.thUndSEI}>Conteo Unidades SEI</th>
                <th className={css.thUndCliente}>Und. FCV aprobadas</th>
                <th className={css.thDiferencia}>Diferencia Conteo</th>
                <th className={css.thObservacion}>Observaciones</th>
                <th className={css.thOk}>Aprobación Unidades Cliente</th>
                <th className={css.thOkSEI}>
                    <HeaderConFiltro
                        nombre="Aprobación Unidades SEI"
                        filtro={filtro || []}
                        actualizarFiltro={actualizarFiltros.bind(this, 'filtroAprobacionSei')}
                    />
                </th>
            </tr>
            </thead>
            <tbody>
            {children}
            </tbody>
        </table>
    </div>



// WEBPACK FOOTER //
// ./frontEnd/inventarios/diferencias-inventarios/TablaInventarios.jsx